export default {
    upload: 'Datei hochladen',
    orDragAndDrop: 'oder hierher ziehen',

    wrongFileType: 'Falscher Dateityp. Es werden nur folgende Dateitypen unterstützt: {fileType}',
    uploadError: 'Fehler beim Hochladen der Datei',
    acceptedFormats: 'Erlaubte Formate: {formats}',
}
